import { SmartImage } from "@/components/SmartImage";
import { scrollToId } from "@/hooks/useScrollSpy";
import { SECTIONS, RESTAURANT, sectionAnchor } from "@/data/menu";
import { Phone, MapPin } from "lucide-react";

export const Sidebar = ({ activeSection }) => {
  return (
    <aside className="sticky top-0 hidden h-screen w-[300px] shrink-0 flex-col border-r border-roty-line bg-roty-paper lg:flex xl:w-[330px]">
      <div className="flex flex-1 flex-col overflow-y-auto px-8 py-9">
        {/* Brand */}
        <button
          type="button"
          data-testid="sidebar-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 text-left"
        >
          <SmartImage
            base="logo"
            alt="ROTY FOOD Pizza & Coffee"
            width={64}
            height={71}
            widths={[120, 200, 300]}
            sizes="64px"
            eager
            className="h-16 w-auto"
          />
          <span className="leading-none">
            <span className="block roty-display text-2xl text-roty-red">ROTY FOOD</span>
            <span className="mt-1 block text-[11px] font-bold uppercase tracking-[0.22em] text-roty-gold-dark">
              Pizza &amp; Coffee
            </span>
          </span>
        </button>

        {/* Section nav */}
        <nav className="mt-11" data-testid="sidebar-nav">
          <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.24em] text-roty-ash/70">
            Meniu
          </p>
          <ul className="space-y-0.5">
            {SECTIONS.map((s) => {
              const active = s.id === activeSection;
              return (
                <li key={s.id}>
                  <button
                    type="button"
                    data-testid={`sidebar-link-${s.id}`}
                    onClick={() => scrollToId(sectionAnchor(s))}
                    className={`flex w-full items-center border-l-2 py-2 pl-3 text-left transition-colors ${
                      active
                        ? "border-roty-red text-roty-red"
                        : "border-transparent text-roty-ink hover:border-roty-gold hover:text-roty-red"
                    }`}
                  >
                    <span className="roty-display text-xl">{s.label}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="mt-auto pt-10">
          {/* Contact */}
          <div className="border-t border-roty-line pt-6 space-y-2 text-sm">
            <a
              href={`tel:${RESTAURANT.phone.replace(/\s/g, "")}`}
              data-testid="sidebar-phone"
              className="flex items-center gap-2 font-bold text-roty-ink transition-colors hover:text-roty-red"
            >
              <Phone className="h-4 w-4 text-roty-red" strokeWidth={2.5} />
              {RESTAURANT.phone}
            </a>
            <p className="flex items-center gap-2 text-roty-ash">
              <MapPin className="h-4 w-4 text-roty-gold-dark" strokeWidth={2.5} />
              Valea Bourei · Suceava
            </p>
          </div>
        </div>
      </div>
    </aside>
  );
};
